module.exports = __webpack_public_path__ + "static/media/filter-outline.d2c3eba6.svg";